var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.ifEdit)?_c('release-sku-edit',{attrs:{"product-audit-id":_vm.productAuditId,"if-edit":_vm.ifEdit}}):_c('sku-edit',{attrs:{"sku-id":_vm.skuId,"product-audit-id":_vm.productAuditId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }